import { atom, selector } from 'recoil';

export const consulteeIdState = atom<number>({
  key: 'consulteeId',
  default: 0,
});

export const consulteeNameState = atom<string>({
  key: 'consulteeName',
  default: '',
});

export const consulteeEmailState = atom<string>({
  key: 'consulteeEmail',
  default: '',
});

export const consulteeOrganisationIdsState = atom<number[]>({
  key: 'consulteeOrganisationIds',
  default: [],
});

export const consulteeParentOrganisationIdsState = atom<number[]>({
  key: 'consulteeParentOrganisationIds',
  default: [],
});

export const isAdminState = atom<boolean>({
  key: 'isAdmin',
  default: false,
});

export const isConsulteeState = atom<boolean>({
  key: 'isConsultee',
  default: false,
});

export const isTQAdminState = atom<boolean>({
  key: 'isTQAdmin',
  default: false,
});

export const hasPermissionState = selector<boolean>({
  key: 'hasPermission',
  get: ({ get }) => get(isAdminState) || get(isConsulteeState) || get(isTQAdminState),
});

export const isAdminOrConsulteeState = selector<boolean>({
  key: 'isAdminOrConsultee',
  get: ({ get }) => get(isAdminState) || get(isConsulteeState),
});

export const permissionValuesState = selector({
  key: 'permissionValuesValues',
  get: ({ get }) => {
    return {
      consulteeId: get(consulteeIdState),
      consulteeName: get(consulteeNameState),
      consulteeOrganisationIds: get(consulteeOrganisationIdsState),
    };
  },
});
